const isSet = (value) => !!value || value === 0;

const getValueRange = (min, max) => {
  if (!isSet(min) && !isSet(max)) {
    return null;
  }
  if (isSet(min) && !isSet(max)) {
    return `≥ ${min}`;
  }
  if (!isSet(min) && isSet(max)) {
    return `≤ ${max}`;
  }
  return `${min} - ${max}`;
};

export const getFiltersToDisplay = (filters) => {
  const filtersToDisplay = {};

  Object.keys(filters).forEach((key) => {
    if (
      ![
        'includeHistoricalParticipants',
        'opportunities',
        'operator',
        'assets',
        'countries',
        'companies',
        'basins',
        'assetUnits',
      ].includes(key)
    ) {
      return;
    }
    const value = filters[key];
    if (Array.isArray(value) && value.length === 0) return;
    if (!value) return;

    filtersToDisplay[key] = value;
  });

  return filtersToDisplay;
};

const getValueCheckboxes = (value, fullArrayLength) => {
  if (!value || (Array.isArray(value) && (value.length === 0 || value.length === fullArrayLength)))
    return null;

  return value;
};

export const getCheckboxFiltersToDisplay = (filters, checkListItems) => {
  const filtersToDisplay = {};

  const developmentStatuses = getValueCheckboxes(
    filters.developmentStatuses,
    checkListItems?.developmentStatuses?.length,
  );
  if (developmentStatuses) filtersToDisplay.developmentStatuses = developmentStatuses;

  const resourceThemes = getValueCheckboxes(
    filters.resourceThemes,
    checkListItems?.resourceThemes?.length,
  );
  if (resourceThemes) filtersToDisplay.resourceThemes = resourceThemes;

  const shoreStatuses = getValueCheckboxes(
    filters.shoreStatuses,
    checkListItems?.shoreStatuses?.length,
  );
  if (shoreStatuses) filtersToDisplay.shoreStatuses = shoreStatuses;

  return filtersToDisplay;
};

export const getRangeFiltersToDisplay = (filters) => {
  const filtersToDisplay = {};

  const npv = getValueRange(filters.npvMin, filters.npvMax);
  if (npv) filtersToDisplay.npv = npv;
  const reserves = getValueRange(filters.reservesMin, filters.reservesMax);
  if (reserves) filtersToDisplay.reserves = reserves;
  const production = getValueRange(filters.productionMin, filters.productionMax);
  if (production) filtersToDisplay.production = production;

  return filtersToDisplay;
};

export const getLabel = (key) => {
  switch (key) {
    case 'resourceThemes':
      return 'Resource Themes';
    case 'shoreStatuses':
      return 'Shore Statuses';
    case 'developmentStatuses':
      return 'Development Statuses';

    case 'production':
    case 'reserves':
    case 'npv':
    case 'countries':
    case 'assets':
    default:
      return key.charAt(0).toUpperCase() + key.slice(1);
  }
};
